function OnSuccessSubmitCallback(result) {
    $("#btn-submit-webcallback").attr("disabled", "true");
    if (result.IsValid) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $('#wrapper-webcallback').html(result._Merci);
    } else {
        if (result._WebCallbackForm !== null) {
            $('#wrapper-webcallback').html(result._WebCallbackForm);
            Foundation.libs.webcallback.initBindings();
            Foundation.libs.webcallback.initDatepicker();

            if (result._InitTimepicker) {
                Foundation.libs.webcallback.initTimepicker(result._StartMinTime, result._StartMaxTime, result._EndMinTime, result._EndMaxTime);
            }
        }
    }

    $("#btn-submit-webcallback").removeAttr("disabled");
}

